import { ArrowUpIcon, IconButton, PauseIcon } from '@farol-ds/react'
import { composeRefs } from '@radix-ui/react-compose-refs'
import React, { forwardRef } from 'react'

import { useChatInputShellContext } from './chat-input-shell-context'

export interface ChatInputShellSubmitButtonProps {
  busy?: boolean
  disabled?: boolean
  busyLabel?: string
  idleLabel?: string
  className?: string
  onClick?: (evt: React.MouseEvent<HTMLButtonElement>) => void
}

export const ChatInputShellSubmitButton = forwardRef<
  HTMLButtonElement,
  ChatInputShellSubmitButtonProps
>(function ChatInputShellSubmitButton(props, forwardedRef) {
  const {
    busy: busyProp,
    disabled: disabledProp,
    busyLabel = 'Interromper',
    idleLabel = 'Enviar',
    className,
    onClick,
  } = props

  const ctx = useChatInputShellContext()
  const busy = busyProp ?? ctx.busy
  const disabled = disabledProp ?? ctx.disabled

  return (
    <IconButton
      type="submit"
      kind="primary"
      icon={busy ? <PauseIcon /> : <ArrowUpIcon />}
      label={busy ? busyLabel : idleLabel}
      size="sm"
      disabled={disabled}
      className={className}
      onClick={onClick}
      ref={composeRefs(forwardedRef, ctx.submitRef)}
    />
  )
})
